import React from 'react';

const AllianceDiplomacy = () => {
  return <h1>AllianceDiplomacy Page</h1>;
};

export default AllianceDiplomacy;
